import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { ArticleBlog } from '@/utils/types/Article'

export default function useSeo(article: ArticleBlog) {
  const category = article.categories?.[0]

  const globalStore = useGlobalStore()

  const title = `${article.seo?.meta_title || article.subject || ''}｜${category.seo?.meta_title || category.subject || ''}｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = article.seo?.meta_description
  const url = article.seo?.canonical || `${import.meta.env.VITE_DOMAIN}/blog/article/${article.seo?.meta_slug || article.id}`
  const parentCategory = category.parent

  const breadcrumbs: { title: string; isActive: boolean; url: string }[] = [
    { title: '品牌部落格', isActive: false, url: '/blog' }
  ]
  if (parentCategory) {
    breadcrumbs.push({ title: parentCategory.subject, isActive: false, url: `/blog/${category.parent_id}` })
  }
  breadcrumbs.push({ title: category.subject, isActive: true, url: `/blog/${category.parent_id}/${category.id}` })

  globalStore.setBreadcrumbs(breadcrumbs)

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: article.seo?.og_image?.link,
    keywords: article.seo?.meta_keywords?.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '品牌部落格',
            item: `${import.meta.env.VITE_DOMAIN}/blog`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: category.subject,
            item: `${import.meta.env.VITE_DOMAIN}/blog/${category.parent_id}/${category.id}`
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: article.subject,
            item: url
          }
        ]
      }
    ]
  })
}
